<template>
  <div class="MsgForm">
    <div class="form_wrap">
      <span class="title">
        供应商资质
        <span class="tips"> <img class="icon_tips2" src="@/assets/img/icon_tips2.png" alt />请申请入围供应商上传全部有效资质证书 </span>
      </span>
      <div class="btn_wrap">
        <img src="@/assets/img/btn_add.png" alt @click="add('qualificationList')" />
        <img src="@/assets/img/btn_delete.png" alt @click="removeRualification" />
      </div>
      <table>
        <tbody>
          <tr>
            <th width="40px">
              <el-checkbox v-model="allQualificationCheck"></el-checkbox>
            </th>
            <th width="200px">证照名称</th>
            <th width="180px">发证机构</th>
            <th width="180px">证件号</th>
            <th width="300px">使用期限</th>
            <th width="60px">是否长期</th>
            <th>附件</th>
            <th width="150px" v-if="auditStatus">操作</th>
          </tr>
          <tr v-for="(item, index) in qualificationList" :key="index">
            <td>
              <el-checkbox v-model="item.check" v-if="!item.IsMust"></el-checkbox>
            </td>
            <td>
              <span v-if="item.IsMust">
                <span class="icon_must">*</span>
                <el-popover placement="top-start" width="400" trigger="hover" v-if="item.FileTypeName == '一般纳税人资格证明'">
                  <div style="color: #ff6600; font-size: 14px">
                    <p>税局出具的纳税事项通知书或官网的资格查询结果</p>
                  </div>
                  <span slot="reference">
                    <span>{{ item.FileTypeName }}</span>
                  </span>
                </el-popover>
                <!-- <el-tooltip content="税局出具的纳税事项通知书或官网的资格查询结果" placement="top" v-if="item.FileTypeName=='一般纳税人资格证明'">
                
                </el-tooltip> -->
                <span v-else> {{ item.FileTypeName }}</span>
              </span>
              <el-input v-model="item.FileTypeName" v-if="!item.IsMust" :disabled="!auditStatus"></el-input>
            </td>
            <td>
              <el-input v-model="item.IssuingAuthority" :disabled="!auditStatus"></el-input>
            </td>
            <td>
              <el-input v-model="item.CertificateNo" :disabled="!auditStatus"></el-input>
            </td>
            <td class="custom_date custom_normal" v-if="item.IsLongServiceDate">
              <div class="datepicker_wrap">
                <el-date-picker class="filedate filedate1" value-format="yyyy-MM-dd" v-model="item.ServiceLifeDate[0]" type="date" :disabled="!auditStatus" placeholder="开始日期"></el-date-picker>
              </div>
            </td>
            <td class="custom_date custom_daterange" v-else>
              <el-date-picker :disabled="!auditStatus" v-model="item.ServiceLifeDate" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels></el-date-picker>
            </td>
            <td>
              <el-checkbox :disabled="!auditStatus" v-model="item.IsLongServiceDate" class="term" @change="longterm($event, index)"></el-checkbox>
            </td>
            <td>
              <span class="filename" @click="download(item.FileId, item.Remark, item.FileName)" v-if="item.FileId !== 0 || item.Remark !== ''">{{ item.FileName }}</span>
            </td>

            <td class="operation" v-if="auditStatus">
              <span class="files">
                <span class="oText">上传附件</span>
                <input type="file" class="avatar" name="avatar" accept=".pdf" @change="upload(index)" />
              </span>
              <span class="link" @click="deleteFile(index, 1)" v-if="item.FileId !== '0' || item.Remark !== ''">删除附件</span>
              <span class="template" @click="downloadTemplate(item.TemplatefilePath, item.FileName)" v-if="item.TemplatefilePath">下载模板</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="line"></div>
    </div>
    <div class="form_wrap">
      <span class="title">其他附件</span>
      <div class="btn_wrap">
        <img src="@/assets/img/btn_add.png" alt @click="add('enclosureList')" />
        <img src="@/assets/img/btn_delete.png" alt @click="removeEnclosure" />
      </div>
      <table class="enclosure">
        <tbody>
          <tr>
            <th width="40px">
              <el-checkbox v-model="allEnclosureCheck"></el-checkbox>
            </th>
            <th width="300px">附件名称</th>
            <th>附件</th>
            <th width="260px" v-if="auditStatus">操作</th>
          </tr>
          <tr v-for="(item, index) in enclosureList" :key="index">
            <td>
              <el-checkbox v-model="item.check" v-if="!item.IsMust"></el-checkbox>
            </td>
            <td>
              <el-popover placement="top-start" width="400" trigger="hover" v-if="item.FileTypeName == '本行业有效期内的从业资质文件'">
                <div style="color: #ff6600; font-size: 14px">
                  <p>1、商品/服务类：有关行业从业要求相关资质。</p>
                  <p>2、外包/送检类（计量校准检定、检测、认证、能力验证）：有关获得认可资质（CNAS、法定计量授权、军用实验室认可、CMA、国防认可（DLAC）、装备承制单位、军用实验室认可）</p>
                  <p>3、工程建设类供：工程造价资质、工程咨询资质、工程监理资质、安装工程资质、消防工程资质、施工企业资质、安全生产许可证等。</p>
                </div>

                <span slot="reference"> <img class="icon_tips2" src="@/assets/img/icon_tips0.png" align="middle" alt /></span>
              </el-popover>
              <span v-if="item.IsMust">
                <span class="icon_must">*</span>
                {{ item.FileTypeName }}
              </span>
              <el-input v-model="item.FileTypeName" v-if="!item.IsMust" :disabled="!auditStatus"></el-input>
            </td>
            <td>
              <span class="filename filename2" @click="download(item.FileId, item.Remark, item.FileName)" v-if="item.FileId !== 0 || item.Remark !== ''">{{ item.FileName }}</span>
            </td>

            <td class="operation" v-if="auditStatus">
              <span class="files">
                <span class="oText">上传附件</span>
                <input type="file" class="file" name="file" accept=".pdf" @change="upload1(index)" />
              </span>
              <span class="link" @click="deleteFile(index, 2)" v-if="item.FileId !== '0' || item.Remark !== ''">删除附件</span>
              <span class="template" v-if="item.TemplatefilePath" @click="downloadTemplate(item.TemplatefilePath, item.FileTypeName)">下载模板</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    FileList: Array,
    auditStatus: {
      type: Boolean,
      default: true
    },
    TaxPayerSize: String
  },
  data() {
    return {
      value: '',
      allQualificationCheck: '',
      allEnclosureCheck: '',
      qualificationList: [],
      enclosureList: [],
      list: [],
      iserror: true,
      file: {
        check: false,
        CertificateNo: null,
        FileId: 0,
        FileName: '',
        FileType: 1,
        FileTypeName: '一般纳税人资格证明',
        IsMust: true,
        IssuingAuthority: null,
        QualificationId: 0,
        Remark: '',
        ServiceLifeDate: ['', ''],
        IsLongServiceDate: false,
        TemplatefilePath: ''
      }
    }
  },
  watch: {
    allQualificationCheck(val) {
      this.qualificationList.forEach((element) => {
        if (element.hasOwnProperty('check')) {
          element.check = val
        }
      })
    },
    allEnclosureCheck(val) {
      this.enclosureList.forEach((element) => {
        if (element.hasOwnProperty('check')) {
          element.check = val
        }
      })
    },
    FileList(val) {
      ;(this.qualificationList = []),
        (this.enclosureList = []),
        this.FileList.forEach((item) => {
          if (item.FileType == 1) {
            this.qualificationList.push(item)
          } else {
            this.enclosureList.push(item)
          }
        })
    },
    TaxPayerSize(val) {
      if (val === '1') {
        this.qualificationList = this.qualificationList.filter((item) => {
          return item.FileTypeName != '一般纳税人资格证明'
        })
      } else {
        var flag = true
        this.qualificationList.forEach((item) => {
          if (item.FileTypeName == '一般纳税人资格证明') {
            flag = false
          }
        })
        if (flag == true) {
          this.qualificationList.unshift(this.file)
        }
      }
    }
  },
  mounted() {
    this.FileList.forEach((item) => {
      if (item.FileType == 1) {
        this.qualificationList.push(item)
      } else {
        this.enclosureList.push(item)
      }
      if (item.FileTypeName === '一般纳税人资格证明') {
        this.file = item
      }
    })
    if (this.TaxPayerSize === '1') {
      this.qualificationList = this.qualificationList.filter((item) => {
        return item.FileTypeName != '一般纳税人资格证明'
      })
    }
    // else{
    //   this.qualificationList.unshift(this.file)
    // }
  },
  methods: {
    longterm(val, index) {
      var that = this
      if (val && !that.qualificationList[index].ServiceLifeDate) {
        that.qualificationList[index].ServiceLifeDate = ['', '']
      }
      // } else {
      // that.qualificationList[index].ServiceLifeTime="";
      // }
    },
    add(name) {
      const obj = {
        check: false,
        CertificateNo: null,
        FileId: 0,
        FileName: '',
        FileType: name == 'qualificationList' ? 1 : 2,
        FileTypeName: '',
        IsMust: false,
        IssuingAuthority: null,
        QualificationId: 0,
        Remark: '',
        ServiceLifeDate: ['', ''],
        IsLongServiceDate: false,
        TemplatefilePath: ''
      }
      if (name == 'qualificationList') {
        this.qualificationList.push(obj)
      } else {
        this.enclosureList.push(obj)
      }
    },
    removeRualification() {
      this.qualificationList = this.qualificationList.filter((item) => {
        return !item.check
      })
    },
    removeEnclosure() {
      this.enclosureList = this.enclosureList.filter((item) => {
        return !item.check
      })
    },
    download(fileId, remark, fileName) {
      let token = window.localStorage.getItem('loginToken')
      var url = 'SupplierLogin/DownLoadFile?fileId=' + fileId + '&remark=' + remark + '&token=' + token + '&fileName=' + fileName

      this.downloadfile(this.baseURL + url)
    },
    downloadTemplate(TemplatefilePath, FileName) {
      var url = 'SupplierLogin/DownloadTemplate?TemplatefilePath=' + TemplatefilePath + '&FileName=' + FileName
      this.downloadfile(this.baseURL + url)
    },
    upload(index) {
      let filesDom = document.getElementsByClassName('avatar')[index]
      const file = filesDom.files[0]
      var name = file.name
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg.toLowerCase() === 'pdf'
      if (!extension) {
        this.$message.error('请上传pdf文件！')
        filesDom.value = ''
        return
      }
      if (file.size > 200 * 1024 * 1024) {
        this.$message.error('请上传小于200M的文件！')
        filesDom.value = ''
        return
      }
      var formData = new window.FormData()
      formData.append('file', file)

      this.uploadFileRequest('SupplierLogin/UploadFile', formData).then((res) => {
        if (res.data.errcode == 0) {
          this.qualificationList[index].FileId = res.data.fileid
          this.qualificationList[index].FileName = name
          this.qualificationList[index].Remark = ''
          filesDom.value = ''
        }
      })
    },
    upload1(index) {
      let filesDom = document.getElementsByClassName('file')[index]
      const file = filesDom.files[0]
      var name = file.name
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg.toLowerCase() === 'pdf'
      if (!extension) {
        this.$message.error('请上传pdf文件！')
        filesDom.value = ''
        return
      }
      if (file.size > 200 * 1024 * 1024) {
        this.$message.error('请上传小于200M的文件！')
        filesDom.value = ''
        return
      }
      var formData = new window.FormData()
      formData.append('file', file)
      this.uploadFileRequest('SupplierLogin/UploadFile', formData).then((res) => {
        if (res.data.errcode == 0) {
          this.enclosureList[index].FileId = res.data.fileid
          this.enclosureList[index].FileName = name
          filesDom.value = ''
        }
      })
    },
    deleteFile(index, flag) {
      if (flag == 1) {
        this.qualificationList[index].FileId = 0
        this.qualificationList[index].Remark = ''
      } else {
        this.enclosureList[index].FileId = 0
        this.enclosureList[index].Remark = ''
      }
    },
    ruleList() {
      this.list = []
      this.iserror = true

      this.qualificationList.forEach((item) => {
        if (!item.IssuingAuthority && this.iserror) {
          this.$message.error('请填写(' + item.FileTypeName + ')发证机构')
          this.iserror = false
          return false
        }
        if (!item.CertificateNo && this.iserror) {
          this.$message.error('请填写(' + item.FileTypeName + ')证件号')
          this.iserror = false
          return false
        }
        if ((!item.ServiceLifeDate || !item.ServiceLifeDate[0] || (!item.ServiceLifeDate[1] && item.IsLongServiceDate === false)) && this.iserror) {
          this.$message.error('请填写(' + item.FileTypeName + ')使用期限')
          this.iserror = false
          return false
        }

        if (item.FileId == 0 && item.Remark == '' && this.iserror) {
          this.$message.error('请上传(' + item.FileTypeName + ')附件')
          this.iserror = false
          return false
        }
      })

      this.enclosureList.forEach((item) => {
        if (item.FileId == 0 && item.Remark == '' && this.iserror) {
          this.$message.error('请上传(' + item.FileTypeName + ')附件')
          this.iserror = false
          return false
        }
      })
      // console.log("...this.qualificationList",this.qualificationList);
      //  console.log("...this.enclosureList",this.enclosureList);

      this.list.push(...this.qualificationList)
      this.list.push(...this.enclosureList)
    },
    ruleList1() {
      this.list = []
      this.list.push(...this.qualificationList)
      this.list.push(...this.enclosureList)
    }
  }
}
</script>

<style lang="scss" scoped>
.operation {
  align-items: center;

  .files {
    position: relative;
    flex: 1;

    .oText {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      line-height: 23px;
      cursor: pointer;
    }

    input {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      opacity: 0;
      cursor: pointer;
    }
  }

  .template {
    flex: 1;
  }
}

.link {
  cursor: pointer;
}

.filename {
  cursor: pointer;
  white-space: nowrap;
  width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  color: #0066cc;
}

.filename2 {
  width: auto;
}

.tips {
  font-size: 14px;
  color: #ff6600;
}

.icon_tips2 {
  margin-right: 3px;
  margin-left: 6px;
  vertical-align: bottom;
}

// .filedate{width:65%}
// .custom_date ::v-deep.el-date-editor {
//   width: 49% !important;
// }
.custom_date ::v-deep.el-range-editor {
  width: 100% !important;
}

.custom_daterange ::v-deep.el-range-input {
  height: 34px;
  line-height: 34px;
  font-size: inherit;
}

.custom_daterange ::v-deep.el-date-editor {
  height: auto;
}

.datepicker_wrap {
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 3px;
}

.datepicker_wrap ::v-deep.el-input__inner {
  border: none !important;
  border-radius: 4px;
  background: #fff;
}

.filedate2 ::v-deep.el-input__prefix {
  .el-icon-date {
    position: relative;
  }

  .el-icon-date:before {
    content: '';
    width: 4px;
    height: 1px;
    position: absolute;
    top: 50%;
    left: 0;
    background: #303133;
    clear: both;
  }
}

.filedate2 ::v-deep.el-input__inner {
  padding-left: 24px !important;
}

.filedate2 ::v-deep.el-input__prefix {
  left: -4px;
}

.filedate1 ::v-deep.el-input__prefix {
  left: -3px;
}

.filedate1 ::v-deep.el-input__inner {
  padding-left: 40px !important;
  padding-right: 40px !important;
  text-align: center;
}

.filedate1 ::v-deep.el-input__icon {
  line-height: 33px;
}

.popover_1 {
  margin-left: 15px;
  color: darkorange;

  .icon_tips2 {
    padding-right: 5px;
  }

  .icon_must {
    font-weight: bold;
    margin-right: 5px;
    color: #f56c6c;
  }
}
</style>